/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import MaintainGroupPlanCustomNaviation from './maintainGroupPlanCustomNavigation';
import MaintainGroupPlanDateRenderComponent from './maintainGroupPlanDateRenderComponent';

const MaintainGroupPlan = ({
  setFullScreenView,
  fullScreenView,
  data,
  cellHead,
}) => {
  const frameworkComponents = {
    CustomNavigationComponent: MaintainGroupPlanCustomNaviation,
    dateRenderComponent: MaintainGroupPlanDateRenderComponent,
    planNameRender: (cellData) => {
      const name = cellData && cellData.data.planName;
      if (name && name.length > 16) {
        return (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
          >
            <div>{name}</div>
          </OverlayTrigger>
        );
      }
      return <div>{name}</div>;
    },
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  return (
    <div className="panel tBillPanel-space pb-0">
      <div className="clearfix" />
      <Grid
        rowData={data}
        defaultCol={{ editable: false }}
        columnDefs={cellHead}
        gridHeight={fullScreenView ? '100vh' : 350}
        frameworkComponents={frameworkComponents}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        exportFile
        data-testid="onEditingStopped"
        fileName="Group Plans"
      />
    </div>
  );
};

export default MaintainGroupPlan;
